import { useEffect } from 'react'
const listenerStack = [] as ((e: any) => void)[]

const addListener = (handler: (e: any) => void) => {
  //if there is already a esc listener on the document
  if (listenerStack.length) {
    //... get the latest listener
    const currentListener = lastEl(listenerStack)
    //... and remove it
    document.removeEventListener('keydown', currentListener)
  }
  // add the new listener to the document
  document.addEventListener('keydown', handler)

  // push the new listener handler to the end of the stack
  listenerStack.push(handler)
}

const removeListener = (handler: (e: any) => void) => {
  //remove the listener from the DOM
  document.removeEventListener('keydown', handler)
  //handler is last on the list (usual case)
  if (lastEl(listenerStack) === handler) {
    //pop it off the stack
    listenerStack.pop()
    // add the next listener on the stack(if present)
    const nextListener = lastEl(listenerStack)
    document.addEventListener('keydown', nextListener)
  } else {
    //remove the listener from the stack
    const seekingIdx = listenerStack.findIndex((test) => test === handler)
    listenerStack.splice(seekingIdx)
  }
}

function lastEl(arr: any[]): any | undefined {
  return arr[arr.length - 1]
}

/**
 * Simply pass in a handler and the latest handler will be used when a component is unmounted,
 *  the cleanup function will set the next handler as the main handler
 *
 * @param handler the function to run when esc is pressed
 */
export function useHandleEscapeKey(handler: (e: KeyboardEvent) => void): void {
  useEffect(() => {
    const handleDocumentKeyChange = (e: any) => {
      if (e.key === 'Escape') {
        handler(e)
      }
    }
    addListener(handleDocumentKeyChange)
    return () => {
      removeListener(handleDocumentKeyChange)
    }
  }, [handler])
}
